export const siteInfo = {
  name: '爱情岛线路',
  tagline: '专属定制浪漫之旅',
  description: '探索最美爱情岛线路，为您精心规划浪漫行程。无论是蜜月旅行、情侣度假还是求婚之旅，我们提供完整的爱情岛线路攻略，涵盖交通、住宿、景点与特色体验，让每段旅程都成为难忘的爱情故事。',
  phone: '400-888-6688',
  email: 'hello@lfjzfp.cn',
  address: '海南省三亚市天涯区爱情岛旅游服务中心',
  wechat: 'aiqingdao520',
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '蜜月行程', path: '/category/honeymoon' },
  { label: '情侣度假', path: '/category/couple' },
  { label: '求婚之旅', path: '/category/proposal' },
  { label: '自由行', path: '/category/free-travel' },
  { label: '关于我们', path: '/about' },
];

export const categories = [
  {
    slug: 'honeymoon',
    name: '蜜月行程',
    icon: 'ri-heart-line',
    description: '为新婚夫妇精心策划的浪漫蜜月线路，享受二人世界的甜蜜时光',
    imageSeq: 'cat-honeymoon',
  },
  {
    slug: 'couple',
    name: '情侣度假',
    icon: 'ri-user-heart-line',
    description: '逃离城市喧嚣，与心爱的TA一起享受悠闲浪漫的海岛假期',
    imageSeq: 'cat-couple',
  },
  {
    slug: 'proposal',
    name: '求婚之旅',
    icon: 'ri-vip-diamond-line',
    description: '在最美的海岛，为TA策划一场终身难忘的浪漫求婚仪式',
    imageSeq: 'cat-proposal',
  },
  {
    slug: 'free-travel',
    name: '自由行线路',
    icon: 'ri-compass-3-line',
    description: '灵活自由的行程安排，随心所欲探索爱情岛的每一个浪漫角落',
    imageSeq: 'cat-free',
  },
  {
    slug: 'group-tour',
    name: '跟团游',
    icon: 'ri-group-line',
    description: '精心设计的团队行程，与志同道合的旅伴共享爱情岛美景',
    imageSeq: 'cat-group',
  },
  {
    slug: 'photo',
    name: '旅拍攻略',
    icon: 'ri-camera-line',
    description: '专业推荐最美拍摄地点，为你们的爱情留下最动人的影像记忆',
    imageSeq: 'cat-photo',
  },
];

export const hotRoutes = [
  {
    slug: 'sunset-romance-3day',
    title: '日落浪漫·三日精华游',
    category: '蜜月行程',
    duration: '3天2晚',
    price: '2999元/人起',
    rating: 4.9,
    reviewCount: 1286,
    imageSeq: 'hot-route-1',
    tags: ['日落巡航', '海滨晚餐', '私密别墅'],
    summary: '从接机到送机，三天两晚的精华行程，涵盖爱情岛最浪漫的日落观赏点、私密海滨晚餐和特色住宿体验。',
  },
  {
    slug: 'island-romance-5day',
    title: '海岛浪漫·五日深度体验',
    category: '情侣度假',
    duration: '5天4晚',
    price: '5299元/人起',
    rating: 4.8,
    reviewCount: 967,
    imageSeq: 'hot-route-2',
    tags: ['浮潜体验', '沙滩漫步', '海岛SPA'],
    summary: '五天深度探索，包含浮潜、沙滩烛光晚餐、双人SPA等丰富体验，让你们尽情享受二人世界。',
  },
  {
    slug: 'lifetime-proposal-4day',
    title: '一生一世·求婚定制之旅',
    category: '求婚之旅',
    duration: '4天3晚',
    price: '8999元/人起',
    rating: 5.0,
    reviewCount: 523,
    imageSeq: 'hot-route-3',
    tags: ['惊喜求婚', '专业摄影', '定制仪式'],
    summary: '专业团队全程策划，从场地布置到摄影记录，为你打造一场令TA感动落泪的完美求婚。',
  },
  {
    slug: 'free-spirit-7day',
    title: '随心所欲·七日自由行攻略',
    category: '自由行',
    duration: '7天6晚',
    price: '4199元/人起',
    rating: 4.7,
    reviewCount: 2156,
    imageSeq: 'hot-route-4',
    tags: ['灵活行程', '自驾推荐', '秘境探索'],
    summary: '提供最全的自由行攻略，包含住宿推荐、交通指南、美食地图和景点分布，让你轻松规划专属旅程。',
  },
];

export const featuredArticles = [
  {
    slug: 'best-season-guide',
    title: '爱情岛最佳旅游季节全攻略：什么时候去最浪漫？',
    category: '蜜月行程',
    thumbnailSeq: 'article-season',
    date: '2026-07-15',
    author: '小爱',
    excerpt: '爱情岛地处热带，全年温暖如春，但不同季节有着截然不同的风情。本文将详细介绍各季节的气候特点、人流量、价格变化以及最适合的旅行方式，帮你挑选最完美的出行时间。',
    readTime: '8分钟',
    tags: ['旅游季节', '气候攻略', '出行建议'],
  },
  {
    slug: 'top10-sunset-spots',
    title: '爱情岛十大最美日落观赏地：每一帧都是壁纸',
    category: '情侣度假',
    thumbnailSeq: 'article-sunset',
    date: '2026-07-10',
    author: '浪漫摄影师',
    excerpt: '我们走遍了爱情岛的每一个角落，为你精选出十个最适合二人共赏日落的绝美地点。从悬崖餐厅到私密沙滩，每一个地点都经过实地考察，附赠拍照技巧和最佳观赏时间。',
    readTime: '12分钟',
    tags: ['日落观赏', '拍照攻略', '景点推荐'],
  },
  {
    slug: 'honeymoon-budget-plan',
    title: '蜜月旅行预算完全指南：从经济型到奢华型全解析',
    category: '蜜月行程',
    thumbnailSeq: 'article-budget',
    date: '2026-07-05',
    author: '小爱',
    excerpt: '蜜月旅行不一定要花大价钱。本文提供三种不同预算级别的蜜月方案，从万元以内的精致小旅行到不限预算的顶级奢华体验，让每对新人都能找到适合自己的浪漫之旅。',
    readTime: '10分钟',
    tags: ['蜜月预算', '费用指南', '方案推荐'],
  },
  {
    slug: 'proposal-plan-complete',
    title: '海岛求婚全攻略：从策划到执行的每一个细节',
    category: '求婚之旅',
    thumbnailSeq: 'article-proposal',
    date: '2026-06-28',
    author: '求婚策划师',
    excerpt: '在海岛求婚是许多人的梦想，但如何策划一场完美的海岛求婚？从戒指选择、场地预约、氛围布置到应急预案，这份全攻略将解答你所有的疑问。',
    readTime: '15分钟',
    tags: ['求婚策划', '仪式指南', '场地推荐'],
  },
  {
    slug: 'island-food-map',
    title: '爱情岛美食地图：不可错过的12家浪漫餐厅',
    category: '自由行',
    thumbnailSeq: 'article-food',
    date: '2026-06-20',
    author: '美食探索者',
    excerpt: '从海边烛光晚餐到山顶星空餐厅，爱情岛隐藏着许多令人惊艳的美食宝地。我们亲测12家最适合情侣用餐的浪漫餐厅，附赠必点菜品和预约技巧。',
    readTime: '9分钟',
    tags: ['美食推荐', '浪漫餐厅', '特色美食'],
  },
  {
    slug: 'travel-photo-tips',
    title: '情侣旅拍秘籍：如何在爱情岛拍出电影感大片',
    category: '旅拍攻略',
    thumbnailSeq: 'article-photo',
    date: '2026-06-15',
    author: '浪漫摄影师',
    excerpt: '想要在爱情岛拍出不输专业摄影师的旅拍大片？本文分享服装搭配、拍摄角度、光线运用和后期调色的全套技巧，让你们的旅行照片充满电影般的浪漫质感。',
    readTime: '11分钟',
    tags: ['旅拍技巧', '摄影攻略', '穿搭建议'],
  },
];

export const faqData = [
  {
    question: '什么时候去爱情岛旅游最合适？',
    answer: '爱情岛全年气候温暖，平均气温在25-30°C之间。最佳旅游时间为每年11月至次年4月，此时降雨较少、阳光充足，非常适合户外活动和海滩度假。5月至10月为雨季，但雨水通常集中在下午，上午仍可享受阳光，且此时游客较少、价格更实惠，也是不错的选择。',
  },
  {
    question: '爱情岛需要签证吗？需要准备哪些证件？',
    answer: '爱情岛位于中国境内，国内游客无需签证。出行前请准备好身份证，如果选择自驾还需要携带驾驶证。建议提前预订船票或机票，旺季（春节、国庆）建议提前1-2个月预订以确保有票。',
  },
  {
    question: '情侣去爱情岛一般玩几天比较合适？',
    answer: '根据我们的经验，3-5天是最受欢迎的选择。3天可以体验核心景点和浪漫项目；5天则能深度探索、享受悠闲假期。如果时间充裕，7天的行程可以让你彻底放松，体验更多特色活动和秘境探索。具体可以根据你的假期时长和预算灵活安排。',
  },
  {
    question: '爱情岛的住宿条件如何？有推荐的浪漫酒店吗？',
    answer: '爱情岛拥有从经济型民宿到五星级度假酒店的全方位住宿选择。浪漫推荐包括：海景别墅（带私人泳池）、悬崖酒店（绝美日出日落）、沙滩木屋（出门即是海滩）。建议提前预订心仪房型，尤其是蜜月套房和特色民宿，旺季常常一房难求。',
  },
  {
    question: '在爱情岛求婚有什么好的方案推荐吗？',
    answer: '我们提供多种求婚方案：沙滩日落求婚（最经典）、海底潜水求婚（最惊喜）、山顶日出求婚（最浪漫）、私人游艇求婚（最奢华）。每一种方案都可以根据你的预算和喜好进行定制。我们建议至少提前2周预约，以便团队做好充分准备。',
  },
  {
    question: '自由行和跟团游哪个更适合情侣？',
    answer: '这取决于你们的旅行偏好。自由行适合喜欢自主探索、享受二人私密时光的情侣，行程灵活但需要自己做攻略；跟团游适合不想操心行程安排、希望有专业导游讲解的情侣，省心省力但行程相对固定。我们也提供"半自由行"方案——住宿和交通由我们安排，每日活动自由选择。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '张先生 & 李女士',
    trip: '蜜月五日深度体验',
    rating: 5,
    content: '感谢爱情岛线路团队为我们策划的蜜月之旅！从接机到送机，每一个细节都安排得妥妥当当。最难忘的是沙滩烛光晚餐，当夕阳染红整片海面的时候，那种浪漫真的无法用言语形容。强烈推荐给所有新婚夫妇！',
    avatarSeq: 'avatar-1',
  },
  {
    id: 2,
    name: '王先生 & 赵女士',
    trip: '求婚定制之旅',
    rating: 5,
    content: '在爱情岛求婚是我做过最正确的决定！团队帮我策划了一场超级惊喜的海底求婚，当我在五彩斑斓的珊瑚礁前单膝跪地时，她哭得稀里哗啦。摄影师完美记录下了每一个瞬间，这些照片我们看了无数遍还是会感动。',
    avatarSeq: 'avatar-2',
  },
  {
    id: 3,
    name: '陈先生 & 刘女士',
    trip: '七日自由行攻略',
    rating: 5,
    content: '第一次去爱情岛自由行有点忐忑，但他们的攻略真的太详细了！每天的行程建议、餐厅推荐、交通方式都很清晰。我们按攻略去了几个他们推荐的秘境海滩，人少景美，简直像私人岛屿一样。下次还会再来！',
    avatarSeq: 'avatar-3',
  },
];